import * as React from "react";

import { cn } from "@/src/lib/utils";
import { Slot } from "@radix-ui/react-slot";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  suffixIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const hasSuffixIcon = !!props.suffixIcon;
    const input = (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          hasSuffixIcon && "pr-9",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
    if (!hasSuffixIcon) {
      return input;
    } else {
      const iconProps = {
        size: 16,
        className:
          "absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-500",
      };
      return (
        <div className="relative">
          {input}
          <Slot {...iconProps}>{props.suffixIcon}</Slot>
        </div>
      );
    }
  },
);
Input.displayName = "Input";

export { Input };
